var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"m-5"},[_vm._v("Side ikke funnet")]),_c('p',[_vm._v("Kanskje du finner det du leter etter fra vår "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("forside")]),_vm._v("?")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }